<div class="container isBackgoround" style="padding: 0px">
  <main>
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
      class="container_min v-application v-application--is-ltr theme--light"
    >
      <h1 class="mb-10 h3" style="margin-top: 40px">認証メール送信完了</h1>
      <div
        class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
      ></div>
      <img
        class="mb-10"
        width="170px"
        src="/assets/collabo-portal/images/icon_mail.svg"
        alt=""
      />

      <div class="mb-10">
        ご登録のメールアドレスに認証メールを送信しました。
      </div>
      <div class="mb-10">
        受信メールからメールアドレスの認証をお願いいたします。
      </div>

      <p class="text-black-58">
        <a
          [routerLink]="['/', 'register-resend']"
          queryParamsHandling="preserve"
          class="text-link"
          >認証メールが届かない方はこちら</a
        >
      </p>
    </div>
  </main>
</div>
